/* global femcare */

femcare.product.accordion = {

    init: function () {
        var $accordion = $('.accordion--product-main');
        if ($accordion.length) {
            femcare.general.accordion.init('.accordion--product-main', 'content');
        }
    }
};